import { isObject } from 'lodash-es';

import type { CustomizedXMarginData, XMarginData } from './formData.model';

export function getXMarginValue(xMargin: XMarginData): XMarginData {
  return isObject(xMargin) ? (xMargin as CustomizedXMarginData).value : (xMargin as number | null);
}
